var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('div',{staticClass:"back-to-top",on:{"click":_vm.scrollToTop}},[_c('div',{staticClass:"icon"},[_c('IconSVG',{attrs:{"handle":"back_to_top"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }